//仓库信息 api

import { axiosPost } from "@/utils/request";

/**
 * 查询
 * @param {*} params
 * @returns
 */
export const listWarehouse = (params) => {
  return axiosPost({
    url: "/warehouse/selectWarehouse",
    data: params,
  });
};

/**
 * 新增
 * @param {*} params
 * @returns
 */
export const addWarehouse = (params) => {
  return axiosPost({
    url: "/warehouse/insertWarehouse",
    data: params,
    tips: true,
  });
};

/**
 * 修改
 * @param {*} params
 * @returns
 */
export const updateWarehouse = (params) => {
  return axiosPost({
    url: "/warehouse/updateWarehouse",
    data: params,
    tips: true,
  });
};

/**
 * 删除
 * @param {*} warehouseId
 * @returns
 */
export const deleteWarehouse = (warehouseId) => {
  return axiosPost({
    url: "/warehouse/deleteWarehouse",
    data: {
      warehouseId,
    },
    tips: true,
  });
};

/**
 * 获取当前用户管理的仓库
 * @returns
 */
export const selectWarehouse = () => {
  return axiosPost({
    url: "/warehouse/selectWarehouseBuUser",
  });
};

/**
 * 获取当前组织上级所能管理的仓库
 */
export const selectSuperWarehouse = () => {
  return axiosPost({
    url: "/warehouse/selectWarehouseByUserParentOrgan",
  });
};

/**
 * 更新仓库与组织的绑定关系
 * @returns
 */
export const updateWarehouseOrganRel = (data) => {
  return axiosPost({
    url: "/warehouse/updateWarehouseOrganRel",
    data: data,
  });
};

/**
 * 仓库权限查询该组织绑定的仓库使用
 * @returns
 */
export const selectWarehouseOrganRel = (data) => {
  return new Promise((resolve, reject) => {
    axiosPost({
      url: '/warehouse/selectWarehouseOrganRel',
      data: data
    }).then(resData => {
      resolve(resData.data.map(item => item.warehouseId))
    })
  })
};
